import React, { useState } from 'react';

const packages = [
  {
    title: "Online Vet",
    startingPrice: "₹199",
    details: [
      "1 time consultation",
      "Call & Video Consultancy",
      "Personalized Advice"
    ],
    buttonLabel: "Book A Veterinarian"
  },
  {
    title: "Essential Care",
    startingPrice: "₹699",
    details: [
      "1 Week Call/Video Consultancy",
      "Curated vet recommendations",
      "Unlimited chat with veterinary professionals",
      "Ticks & Fleas Preventive"
    ],
    buttonLabel: "Book A Veterinarian"
  },
  {
    title: "Pet Nutrition Consultation",
    startingPrice: "₹1499",
    details: [
      "1:1 Call/Video Consultation",
      "Current Diet, Health Issues/Concerns",
      "Supplementation for optimal health",
      "Better weight management and satiety",
      "Healthy Dog Feeding Guide",
      "Custom-tailored nutrition for pets",
      "Balanced home-cooked diet formulations"
    ],
    buttonLabel: "Book A Consultant"
  },
  {
    title: "Online Behavioral Consultations",
    startingPrice: "₹1299",
    details: [
      "New Pet Parenting",
      "Separation Anxiety/Isolation Distress",
      "Aggression towards dogs and strangers",
      "Enhancing Your Dog's Day-to-Day Life",
      "Enrichment + Mental Stimulation",
      "Barking, Destructive Behavior",
      "Rushing the Front Door, Pulling on the Leash",
      "Jumping Up"
    ],
    buttonLabel: "Book A Consultant"
  }
];
const reviews = [
    {
      name: "Ajay Soam",
      date: "December 20, 2019",
      review: "An awesome experience for my cat's prolonged health issue! Thank you Dr. Abhishek for giving deep insight on the problem and quick suggestions for the cure. Thepetnest is amazing. Glad I found it!",
    },
    {
      name: "Vikas Pal",
      date: "February 29, 2020",
      review: "So convenient and they always do extra things to take care of my oliver. Love that all the vets are so friendly 🐶🐶🐶",
    },
    {
      name: "Ritika",
      date: "September 22, 2019",
      review: "Honestly, @thepetnest is the best thing that’s happened to my pet. So perfect for us crazy cat lovers!",
    },
  ];
  const faqItems = [
    {
      question: "How does Adopt a Pet online vet consultation on the phone work?",
      answer:
        "You can book a consultation through our website or app. Once booked, a vet will call you or video call you at the scheduled time to address your pet's health concerns."
    },
    {
      question: "How long does a pet consultation last?",
      answer:
        "Consultations typically last between 10-15 minutes, depending on the complexity of the issue and the type of consultation you choose."
    },
    {
      question: "When should I use a video/text consultation?",
      answer:
        "Use a video consultation when you need a more detailed evaluation of your pet’s health. Text consultations are suitable for less urgent inquiries or follow-up questions."
    },
    {
      question: "What will happen after my pet consultation?",
      answer:
        "After your consultation, the vet will provide you with personalized recommendations, prescriptions if needed, and follow-up instructions. You can also contact the vet if you have further questions."
    }
  ];
  const contentData = [
    {
      title: "Introducing Online Vet Consultation at Adopt a Pet",
      subtitle: "Expert Care at Your Fingertips",
      description: "Welcome to Adopt a Pet's Online Vet Consultation service, where expert veterinary care meets the convenience and comfort of your home. In today's fast-paced world, ensuring your pet receives timely and professional healthcare is crucial, but finding the time for a vet visit can be challenging. That's where we step in. Adopt a Pet, located in the heart of the digital age, offers comprehensive online vet consultations, blending expertise, convenience, and compassion."
    },
    {
      title: "Immediate Access to Veterinary Care",
      description: "Whether you're seeking a free vet consultation near me or need an emergency vet consultation, our platform provides immediate access to veterinary professionals. With online vet consultations, you can connect with licensed veterinarians ready to assist with your pet's health concerns, offering free consultations and advice when you need it most."
    },
    {
      title: "Comprehensive Online Consultation Services",
      description: "Our vet consultation service covers a wide range of pet health aspects, from routine inquiries to urgent health concerns. We understand that every moment matters, which is why our 5-minute veterinary consult and vet phone consultation options are designed to offer quick, reliable answers to your pressing questions."
    },
    {
      title: "Virtual Vet Consult",
      description: "A seamless service allowing pet owners to connect with vets via video call, providing a personal touch and enabling vets to visually assess your pet's condition."
    },
    {
      title: "Emergency Online Vet Consultation",
      description: "For urgent care needs, our emergency service ensures your pet's health issues are addressed promptly, offering peace of mind in critical situations."
    },
    {
      title: "Online Dog Consultation Near Me",
      description: "Our initiative to make pet healthcare accessible includes free initial consultations for dogs, ensuring your furry friend's well-being without immediate costs."
    },
    {
      title: "Why Choose Adopt a Pet's Online Vet Consultation?",
      description: "Ease of Access: No more worrying about scheduling appointments or travel time; access expert vet care from anywhere, anytime."
    },
    {
      title: "Expertise at Your Disposal",
      description: "Our team of experienced veterinarians is equipped to provide comprehensive advice, diagnosis, and treatment plans."
    },
    {
      title: "Cost-Effective Solutions",
      description: "With options like free consultation vets and consult vet services, we offer cost-effective alternatives to traditional vet visits."
    },
    {
      title: "Personalized Care",
      description: "Tailored advice and treatment options that cater specifically to your pet's needs, ensuring the best possible care."
    },
    {
      title: "How It Works",
      description: "1. Schedule Your Consultation: Choose a convenient time for your online vet consultation. 2. Meet with a Vet Online: Connect via video call or phone with one of our experienced veterinarians. 3. Receive Personalized Vet Care: Get immediate advice, diagnosis, or a treatment plan tailored to your pet's needs."
    },
    {
      title: "Ready for Expert Online Veterinary Care?",
      description: "Don't let the stress of scheduling and traveling to vet appointments put your pet's health on hold. Adopt a Pet's Online Vet Consultation service is here to provide expert care, guidance, and peace of mind, all from the comfort of your home. Contact us today to schedule your online vet consultation or explore our range of online veterinary services. Your pet's health and happiness are just a click away with Adopt a Pet."
    }
  ];
  

const Packages = () => {
    const [activeIndex, setActiveIndex] = useState(null);

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  }
  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
          Packages and Rates
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          {packages.map((pkg, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-lg flex flex-col justify-between hover:shadow-xl transition-all duration-300"
            >
              <div>
                <h3 className="text-2xl font-semibold text-gray-800">{pkg.title}</h3>
                <p className="text-xl font-bold text-orange-500 mt-2">
                  Starting at {pkg.startingPrice}
                </p>
                <ul className="space-y-3 text-gray-600 mt-4">
                  {pkg.details.map((detail, idx) => (
                    <li key={idx} className="flex items-center">
                      <span className="text-gray-600">{detail}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-6 flex justify-between items-center">
                <button className="bg-orange-500 text-white py-2 px-6 rounded-lg hover:bg-orange-600 transition-all duration-300 w-full">
                  {pkg.buttonLabel}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
          Reviews from Our Happy Pet Parents
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col"
            >
              <div className="mb-4">
                <h3 className="text-xl font-semibold text-gray-800">{review.name}</h3>
                <p className="text-sm text-gray-500">{review.date}</p>
              </div>
              <p className="text-gray-600 mb-4">{review.review}</p>
              <div className="flex items-center justify-between text-gray-500">
                <span>⭐⭐⭐⭐⭐</span>
                <span className="text-orange-500">Read more</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            Adopt a Pet: India's Most Trusted Online Veterinary Tele-Health Consultation
          </h2>
          <p className="text-lg text-gray-600">
            Experienced Online veterinarians provide immediate, personalized, and expert answers to your concerns.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              Personalized and Expert Answers
            </h3>
            <p className="text-gray-600 mb-4">
              All our Veterinarians pass Adopt a Pet Enhanced Background Check, ensuring that you receive the highest quality care.
            </p>
            <p className="text-gray-600">
              Whether it’s a simple query or an emergency, our veterinarians are ready to assist you with personalized advice for your pet's health.
            </p>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              Trust and Security
            </h3>
            <p className="text-gray-600 mb-4">
              At Adopt a Pet, we prioritize trust and safety. Our veterinarians are thoroughly vetted and experienced, providing reliable and efficient care for your pets.
            </p>
            <p className="text-gray-600">
              With our enhanced background check process, you can rest assured that your pet is in safe hands.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">Frequently Asked Questions</h2>

        <div className="space-y-4">
          {faqItems.map((item, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <div
                onClick={() => toggleAnswer(index)}
                className="flex justify-between items-center cursor-pointer"
              >
                <h3 className="text-xl font-semibold text-gray-800">{item.question}</h3>
                <span className="text-2xl text-gray-600">{activeIndex === index ? '-' : '+'}</span>
              </div>

              {activeIndex === index && (
                <p className="text-gray-600 mt-4">{item.answer}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
    <div className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-6">
        {contentData.slice(0, 1).map((item, index) => (
          <div key={index} className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800">{item.title}</h2>
            <h3 className="text-2xl font-semibold text-gray-600">{item.subtitle}</h3>
            <p className="text-lg text-gray-600 mt-4">{item.description}</p>
          </div>
        ))}

        {contentData.slice(1, 2).map((item, index) => (
          <div key={index} className="text-center mb-12">
            <h3 className="text-2xl font-semibold text-gray-800">{item.title}</h3>
            <p className="text-lg text-gray-600 mt-4">{item.description}</p>
          </div>
        ))}

        {contentData.slice(2, 3).map((item, index) => (
          <div key={index} className="text-center mb-12">
            <h3 className="text-2xl font-semibold text-gray-800">{item.title}</h3>
            <p className="text-lg text-gray-600 mt-4">{item.description}</p>
          </div>
        ))}

        {contentData.slice(6, 10).map((item, index) => (
          <div key={index} className="text-center mb-12">
            <h3 className="text-2xl font-semibold text-gray-800">{item.title}</h3>
            <p className="text-lg text-gray-600 mt-4">{item.description}</p>
          </div>
        ))}

        {contentData.slice(10, 11).map((item, index) => (
          <div key={index} className="text-center mb-12">
            <h3 className="text-2xl font-semibold text-gray-800">{item.title}</h3>
            <p className="text-lg text-gray-600 mt-4">{item.description}</p>
          </div>
        ))}

        {contentData.slice(11, 12).map((item, index) => (
          <div key={index} className="text-center mb-12">
            <button className="bg-orange-500 text-white py-2 px-6 rounded-lg hover:bg-orange-600 transition-all duration-300">
              Book a Veterinarian Now
            </button>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default Packages;
